import React from 'react';
import './GallerySection.css';

function GallerySection({ images }) {
  return (
    <section id="gallery" className="gallery-section animate-on-scroll">
      <div className="container">
        <h2 className="section-title">Our Gallery</h2>
        <div className="gallery-grid">
          {images.length > 0 ? (
            images.map((image, index) => (
              <div key={image.id != null ? image.id : `gallery-${index}-${image.image_url || ''}`} className="gallery-item">
                <img src={image.image_url} alt={image.title} />
                <div className="gallery-overlay">
                  <h3>{image.title}</h3>
                  {image.description && <p>{image.description}</p>}
                </div>
              </div>
            ))
          ) : (
            <p className="no-items">No gallery images available yet.</p>
          )}
        </div>
      </div>
    </section>
  );
}

export default GallerySection;
